import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import './WhyWeWin.css';

const WhyWeWin = () => {
  const [toast, setToast] = useState(null);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const notifications = [
      { title: "Storm Radar Alert", desc: "Collin County hail swath tracked: 2.1 in hail." },
      { title: "Margin Guard Blocked Bid", desc: "Bid on 821 Pine St halted: margin was 18.2% (Target 25%)." },
      { title: "Estimate Generated", desc: "1140 Highland Ave: Scope computed in 42 seconds." }
    ];

    let notificationIndex = 0;

    const triggerNotification = (title, desc, duration = 4000) => {
      setToast({ title, desc });
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, duration);
    };

    const triggerNextNotification = () => {
      const item = notifications[notificationIndex];
      triggerNotification(item.title, item.desc);
      notificationIndex = (notificationIndex + 1) % notifications.length;

      // Queue next one in 18-24 seconds
      const nextDelay = 18000 + Math.random() * 6000;
      timerId = setTimeout(triggerNextNotification, nextDelay);
    };

    let timerId = setTimeout(triggerNextNotification, 6000);

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <div className="roofing-assist-why-win">
      <Navbar theme="light" />

      {/* Dark Navy Hero Wrapper */}
      <div className="hero-wrapper">
        <div className="container">
          <div className="hero-new">
            <div className="eyebrow-new">Why We Win</div>
            <div className="eyebrow-line"></div>
            <h1 className="headline-new">
              We didn't build another<br />
              roofing app.<br />
              <em>We built the system<br />
              that runs the business.</em>
            </h1>
            <p className="subtext-new">
              JobNimbus tracks your jobs. AccuLynx tracks your pipeline. EagleView measures your roofs. None of them run your company. We do.
            </p>
          </div>
        </div>
        
        {/* Ticker Bar */}
        <div className="ticker-bar">
          <div className="ticker-wrap">
            <div className="ticker-track">
              {/* Original group */}
              <div className="ticker-group">
                <div className="ticker-item">Not a CRM &nbsp;·&nbsp; A Command Center</div>
                <div className="ticker-item">5+ Tools Replaced &nbsp;·&nbsp; 1 Login</div>
                <div className="ticker-item">See the Storm Before the Call Comes In</div>
                <div className="ticker-item">Know Your Margin Before the Crew Packs Up</div>
              </div>
              {/* Duplicate clone group for infinite scrolling loop */}
              <div className="ticker-group" aria-hidden="true">
                <div className="ticker-item">Not a CRM &nbsp;·&nbsp; A Command Center</div>
                <div className="ticker-item">5+ Tools Replaced &nbsp;·&nbsp; 1 Login</div>
                <div className="ticker-item">See the Storm Before the Call Comes In</div>
                <div className="ticker-item">Know Your Margin Before the Crew Packs Up</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* THE REAL PICTURE SECTION */}
      <div className="rp-section">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'left' }}>
            <div className="eyebrow" style={{ color: '#d45c1a', marginBottom: '8px' }}>THE REAL PICTURE &mdash; WHAT MOST $3M&ndash;$8M SHOPS ARE RUNNING TODAY</div>
            <div className="eyebrow-line" style={{ margin: '0 0 28px 0' }}></div>
          </div>

          <div className="rp-grid">
            {/* Left Column: What You're Managing Now */}
            <div className="rp-left-col">
              <div className="rp-col-header">WHAT YOU'RE MANAGING NOW</div>
              <div className="rp-stat-group">
                <div className="rp-stat-num red">7+</div>
                <div className="rp-stat-lbl">Disconnected Tools</div>
              </div>

              {/* Card 1: EagleView */}
              <div className="rp-card">
                <div className="rp-card-left">
                  <div className="rp-card-icon">🗺️</div>
                  <div className="rp-card-info">
                    <div className="rp-card-title">EagleView</div>
                    <div className="rp-card-desc">measurements</div>
                  </div>
                </div>
                <div className="rp-card-badge orange">+$99/mo</div>
              </div>

              {/* Card 2: CompanyCam */}
              <div className="rp-card">
                <div className="rp-card-left">
                  <div className="rp-card-icon">📷</div>
                  <div className="rp-card-info">
                    <div className="rp-card-title">CompanyCam</div>
                    <div className="rp-card-desc">job photos</div>
                  </div>
                </div>
                <div className="rp-card-badge orange">+$49/mo</div>
              </div>

              {/* Card 3: JobNimbus */}
              <div className="rp-card">
                <div className="rp-card-left">
                  <div className="rp-card-icon">📁</div>
                  <div className="rp-card-info">
                    <div className="rp-card-title">JobNimbus</div>
                    <div className="rp-card-desc">CRM pipeline</div>
                  </div>
                </div>
                <div className="rp-card-badge orange">+$200/mo</div>
              </div>

              {/* Card 4: QuickBooks */}
              <div className="rp-card">
                <div className="rp-card-left">
                  <div className="rp-card-icon">📓</div>
                  <div className="rp-card-info">
                    <div className="rp-card-title">QuickBooks</div>
                    <div className="rp-card-desc">accounting</div>
                  </div>
                </div>
                <div className="rp-card-badge orange">+$85/mo</div>
              </div>

              {/* Card 5: HailTrace */}
              <div className="rp-card" style={{ borderColor: 'rgba(212, 92, 26, 0.25)' }}>
                <div className="rp-card-left">
                  <div className="rp-card-icon">⚡</div>
                  <div className="rp-card-info">
                    <div className="rp-card-title">HailTrace</div>
                    <div className="rp-card-desc">storm intelligence</div>
                  </div>
                </div>
                <div className="rp-card-badge orange">+$149/mo</div>
              </div>

              {/* Card 6: Podium */}
              <div className="rp-card">
                <div className="rp-card-left">
                  <div className="rp-card-icon">💬</div>
                  <div className="rp-card-info">
                    <div className="rp-card-title">Podium</div>
                    <div className="rp-card-desc">customer messaging</div>
                  </div>
                </div>
                <div className="rp-card-badge orange">+$299/mo</div>
              </div>

              {/* Card 7: Google Sheets */}
              <div className="rp-card">
                <div className="rp-card-left">
                  <div className="rp-card-icon">📊</div>
                  <div className="rp-card-info">
                    <div className="rp-card-title">Google Sheets</div>
                    <div className="rp-card-desc">reporting</div>
                  </div>
                </div>
                <div className="rp-card-badge gray">manual</div>
              </div>

              {/* Left Tags */}
              <div className="rp-tags-row">
                <div className="rp-tag red">7 logins</div>
                <div className="rp-tag red">7 invoices</div>
                <div className="rp-tag red">no single source of truth</div>
              </div>
            </div>

            {/* Middle Column: Divider */}
            <div className="rp-line-col">
              <div className="rp-line"></div>
              <div className="rp-vs">vs</div>
            </div>

            {/* Right Column: With RoofingAssist.AI */}
            <div className="rp-right-col">
              <div className="rp-col-header">WITH ROOFINGASSIST.AI</div>
              <div className="rp-stat-group">
                <div className="rp-stat-num navy">1</div>
                <div className="rp-stat-lbl navy">Command Center</div>
              </div>

              {/* Command Center Container */}
              <div className="rp-cc-container">
                <div className="rp-cc-header">
                  <span style={{ fontSize: '14px', marginRight: '4px' }}>&bull;</span> RoofingAssist.AI &mdash; Command Center
                </div>

                {/* CC Item 1 */}
                <div className="rp-cc-item">
                  <div className="rp-cc-item-left">
                    <span className="rp-cc-check">&#10003;</span>
                    <span>Storm intelligence</span>
                  </div>
                  <div className="rp-cc-badge">built in</div>
                </div>

                {/* CC Item 2 */}
                <div className="rp-cc-item">
                  <div className="rp-cc-item-left">
                    <span className="rp-cc-check">&#10003;</span>
                    <span>Satellite measurement</span>
                  </div>
                  <div className="rp-cc-badge">built in</div>
                </div>

                {/* CC Item 3 */}
                <div className="rp-cc-item">
                  <div className="rp-cc-item-left">
                    <span className="rp-cc-check">&#10003;</span>
                    <span>Job pipeline</span>
                  </div>
                  <div className="rp-cc-badge">built in</div>
                </div>

                {/* CC Item 4 */}
                <div className="rp-cc-item">
                  <div className="rp-cc-item-left">
                    <span className="rp-cc-check">&#10003;</span>
                    <span>Collections</span>
                  </div>
                  <div className="rp-cc-badge">built in</div>
                </div>

                {/* CC Item 5 */}
                <div className="rp-cc-item">
                  <div className="rp-cc-item-left">
                    <span className="rp-cc-check">&#10003;</span>
                    <span>Revenue per job</span>
                  </div>
                  <div className="rp-cc-badge">built in</div>
                </div>

                {/* CC Item 6 */}
                <div className="rp-cc-item">
                  <div className="rp-cc-item-left">
                    <span className="rp-cc-check">&#10003;</span>
                    <span>Crew communication</span>
                  </div>
                  <div className="rp-cc-badge">built in</div>
                </div>

                {/* CC Item 7 */}
                <div className="rp-cc-item">
                  <div className="rp-cc-item-left">
                    <span className="rp-cc-check">&#10003;</span>
                    <span>Financial reporting</span>
                  </div>
                  <div className="rp-cc-badge">built in</div>
                </div>
              </div>

              {/* Right Tags */}
              <div className="rp-tags-row">
                <div className="rp-tag green">1 login</div>
                <div className="rp-tag green">every job</div>
                <div className="rp-tag green">every dollar</div>
              </div>

              {/* Right Column CTA */}
              <div className="rp-right-cta">
                <Link to="/book" className="cta-btn-navy">See the system in action</Link>
                <div className="cta-text-navy">Book a call &nbsp;•&nbsp; No pitch deck &nbsp;•&nbsp; 30 minutes</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* COMPARISON MATRIX SECTION */}
      <div className="comparison-section">
        <div className="container">
          <div className="section-header">
            <div className="eyebrow">How We Think Differently</div>
            <div className="eyebrow-line"></div>
            <h2 className="section-title">Every other tool manages your business. We run it.</h2>
            <p className="section-desc">That's not a tagline. It's a structural difference in how the product is built and what it's built to do.</p>
          </div>

          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>CAPABILITY</th>
                  <th className="ra-header ra-col">RoofingAssist.AI</th>
                  <th>JOBNIMBUS</th>
                  <th>ACCULYNX</th>
                  <th>ROOFR</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="feature-cell">Storm intelligence &mdash; built in</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="txt-orange">Via add-on</td>
                  <td className="txt-orange">Via add-on</td>
                  <td className="txt-dash">&mdash;</td>
                </tr>
                <tr>
                  <td className="feature-cell">Revenue intelligence per job</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="txt-orange">Limited</td>
                  <td className="check-green">&#10003;</td>
                  <td className="txt-orange">Limited</td>
                </tr>
                <tr>
                  <td className="feature-cell">Full revenue cycle management</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="check-green">&#10003;</td>
                  <td className="check-green">&#10003;</td>
                  <td className="txt-orange">Partial</td>
                </tr>
                <tr>
                  <td className="feature-cell">Automated collections</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="txt-orange">Basic</td>
                  <td className="check-green">&#10003;</td>
                  <td className="txt-orange">Basic</td>
                </tr>
                <tr>
                  <td className="feature-cell">Adjuster workflow management</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="txt-orange">Basic</td>
                  <td className="txt-orange">Basic</td>
                  <td className="txt-dash">&mdash;</td>
                </tr>
                <tr>
                  <td className="feature-cell">Commission + crew pay tracking</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="txt-orange">Partial</td>
                  <td className="check-green">&#10003;</td>
                  <td className="txt-dash">&mdash;</td>
                </tr>
                <tr>
                  <td className="feature-cell">Single flat-rate pricing</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="txt-dash">&mdash;</td>
                  <td className="txt-dash">&mdash;</td>
                  <td className="txt-dash">&mdash;</td>
                </tr>
                <tr>
                  <td className="feature-cell">Unified operating system</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="txt-dash">&mdash;</td>
                  <td className="txt-dash">&mdash;</td>
                  <td className="txt-dash">&mdash;</td>
                </tr>
                <tr>
                  <td className="feature-cell">Built specifically for roofing</td>
                  <td className="check-green ra-col">&#10003;</td>
                  <td className="txt-orange">Contractor-focused</td>
                  <td className="check-green">&#10003;</td>
                  <td className="check-green">&#10003;</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* HEAD TO HEAD SECTION */}
      <div className="h2h-section" id="head-to-head">
        <div className="container">
          <div className="section-header">
            <div className="eyebrow">Head to Head</div>
            <div className="eyebrow-line"></div>
            <h2 className="section-title">How we stack up against the tools you're already using.</h2>
            <p className="section-desc">Most roofing software does one thing well. We do everything your operation needs — connected, visible, and live.</p>
          </div>

          <div className="h2h-grid">
            {/* Card 1: JobNimbus */}
            <div className="h2h-card">
              <div>
                <div className="h2h-brand">JobNimbus</div>
                <h3 className="h2h-card-title">The incumbent. Still running the same playbook.</h3>
                <p className="h2h-card-text">
                  Got to market first, built the habit, and has 5,000+ shops on it. The integration list is deep. The trade show booth is big. But the product hasn't moved in years — and operators know it.
                </p>
              </div>
              <div className="h2h-box">
                <div className="h2h-box-label">The Gap We Attack</div>
                <div className="h2h-box-text">UI from 2016. Generic SaaS messaging. No storm layer. No founder voice. No opinion.</div>
              </div>
            </div>

            {/* Card 2: AccuLynx */}
            <div className="h2h-card">
              <div>
                <div className="h2h-brand">AccuLynx</div>
                <h3 className="h2h-card-title">Enterprise depth. Enterprise friction.</h3>
                <p className="h2h-card-text">
                  Plays upmarket. $150+ per user. Deep reporting, sticky contracts, and implementation that locks you in. Customers in Reddit threads call it "bloated." Release cycles are slow.
                </p>
              </div>
              <div className="h2h-box">
                <div className="h2h-box-label">The Gap We Attack</div>
                <div className="h2h-box-text">Complexity without clarity. Built for ops directors, not owner-operators who move fast.</div>
              </div>
            </div>

            {/* Card 3: Roofr */}
            <div className="h2h-card">
              <div>
                <div className="h2h-brand">Roofr</div>
                <h3 className="h2h-card-title">Best brand in the category. Product is fragmenting.</h3>
                <p className="h2h-card-text">
                  VC-backed, aggressively built, strong YouTube presence. Their free measurement play was smart. But they're stretched trying to be everything — and the seams are showing.
                </p>
              </div>
              <div className="h2h-box">
                <div className="h2h-box-label">The Gap We Attack</div>
                <div className="h2h-box-text">Modules that feel bolted together. An AI story that's feature-level, not architectural.</div>
              </div>
            </div>

            {/* Card 4: CompanyCam */}
            <div className="h2h-card">
              <div>
                <div className="h2h-brand">CompanyCam</div>
                <h3 className="h2h-card-title">Most-loved tool in the category. Not a system.</h3>
                <p className="h2h-card-text">
                  Photo documentation done right. Dead-simple UX. Cult-level user base. Every roofer uses it. But it doesn't run the business — it documents one part of it.
                </p>
              </div>
              <div className="h2h-box">
                <div className="h2h-box-label">Our Position</div>
                <div className="h2h-box-text">Partner, don't compete. A CompanyCam-grade photo experience inside the Command Center.</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SITE FOOTER CTA */}
      <footer className="site-footer" id="book">
        <div className="container">
          <div className="sf-eyebrow">READY WHEN YOU ARE</div>
          <h2 className="sf-headline"><strong>One Call.</strong><br /><span><strong>See the operating system live.</strong></span></h2>
          <p className="sf-desc">No pitch deck. No pressure. We walk you through your operations, show you exactly how the radar coordinates, and let you decide if it's worth the switch.</p>
          <Link to="/book" className="sf-btn">Book a Call &rarr;</Link>
        </div>
      </footer>

      {/* Credits */}
      <div className="bottom-credits">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} RoofingAssist.AI. All rights reserved.</p>
          <div style={{ marginTop: '10px' }}>
            <Link to="/">Home</Link>
            <Link to="/why-we-win" className="active">Why We Win</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>

      {/* Notification Toast for interactive simulation */}
      <div className={`notification-toast ${showToast ? 'show' : ''}`} id="toast">
        <div className="notification-icon">⚡</div>
        <div className="notification-content">
          <div className="notification-title" id="toast-title">{toast?.title}</div>
          <div className="notification-desc" id="toast-desc">{toast?.desc}</div>
        </div>
      </div>
    </div>
  );
};

export default WhyWeWin;
